import { Directive, NgModule } from '@angular/core';
import { ProductImageDirectiveGeneric } from '@signature-it/ngx-generic/directives';

@Directive({
    selector: '[product-image]',
    standalone: false
})

export class ProductImageCartDirectiveGeneric extends ProductImageDirectiveGeneric {

    getProductCode(product: object) {
        return product['Barcode'] || "";
    }

    getProductName(product: object) {
        return product['ItemDescription'] || "";
    }

}

@NgModule({
    declarations: [ProductImageCartDirectiveGeneric],
    exports: [ProductImageCartDirectiveGeneric]
})
export class ProductImageCartDirectiveModuleGeneric {}
